import { useRecoilState } from 'recoil';

import { sidebarAtom, SidebarState } from '../../../utils/recoil/atoms/sidebarAtom';

export default function DiscussionNudge() {
  const [, setSidebarState] = useRecoilState(sidebarAtom);

  return (
    <p>
      See{' '}
      <span
        onClick={() => setSidebarState(SidebarState.SECOND_PAGE)}
        style={{ color: 'blue', textDecorationLine: 'underline', cursor: 'pointer' }}
      >
        Discussion
      </span>{' '}
      if you are stuck, or if you want to add something to the{' '}
      <span
        onClick={() => setSidebarState(SidebarState.SECOND_PAGE)}
        style={{ color: 'blue', textDecorationLine: 'underline', cursor: 'pointer' }}
      >
        Discussion.
      </span>
    </p>
  );
}
